import { StyledSpinner } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledWarnMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
  line-height: 2.4rem;
`;

export const StyledLoadingSpinner = styled(StyledSpinner)`
  margin-right: 0.5rem;
`;
